import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UseRewardTypesReturn {
  rewardTypes: string[];
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

/** Distinct reward types (selector options), optionally scoped to one game. */
export function useRewardTypes(gameConfigId?: string): UseRewardTypesReturn {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: queryKeys.gameRewards.rewardTypes(gameConfigId),
    queryFn: () => api.getGameRewardsRewardTypes(gameConfigId),
  });

  return {
    rewardTypes: data?.rewardTypes ?? [],
    loading: isLoading,
    error: error instanceof Error ? error.message : isError ? 'Failed to load reward types' : null,
    refresh: () => {
      refetch();
    },
  };
}
